"use strict";

PF.Field.CheckBox = class CheckBox extends PF.Field
	{
	static get options()
		{
		return {
			html: PF.Field.CheckBox.templates,
			model: new PF.Model({}),
			key: 'value',

			label: '',

			showInfo: true,
			helper: '',
			confirm: false,

			errors: {
				confirm: 'Подтвердите'
			}
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="list pf-check-box-wrapper" pf="wrapper">
					<ul pf="ul">
						<li>
							<label class="item-checkbox item-content" pf="label">
								<input type="checkbox" name="" value="" pf="input">
								<i class="icon icon-checkbox"></i>
							</label>
						</li>
					</ul>
					<div class="info" pf="info">&nbsp</div>
				</div>
			`,
			//language=HTML
			inner: `
				<div class="item-inner">
					<div class="item-title" pf="labelText"></div>
				</div>
			`
		};
		}


	init()
		{
		this.dom.loads(this.html);

		this.dom.element.append(this.dom.wrapper);
		this.dom.label.append(this.dom.inner);

		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');
		this.bindDom({labelText: 'html'}, 'label');

		this.dom.input.bindValue();
		this.dom.input.onChange('value', () => this.model.setData(this.key, this.dom.input.value));
		// this.calc(`model.${this.key}`, 'dom.input.value');
		this.model.onChange(this.key, () => {
			this.validate(true);
		});
		}

	validate(silent, error = undefined)
		{
		if (this.confirm === true)
			{
			if (this.model.get(this.key) !== true)
				{
				return super.validate(silent, this.errors.confirm);
				}
			}
		return super.validate(silent, error);
		}

	};